<div class="quantity-selector">
	<div (click)="decreaseQuantity(); $event.stopPropagation()" class="square">-</div>
	<div class="rectangle">
		{{ quantity }}
	</div>
	<div (click)="increaseQuantity()" class="square">+</div>
</div>
